/* ═══ Scroll Reveal ═══ */
var obs=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('vis');obs.unobserve(e.target)}})},{threshold:.05,rootMargin:'0px 0px -40px 0px'});
document.querySelectorAll('.rv,.rv-scale').forEach(function(el){obs.observe(el)});
setTimeout(function(){document.querySelectorAll('.rv:not(.vis),.rv-scale:not(.vis)').forEach(function(el){el.classList.add('vis')})},3000);

/* Scroll top button */
window.addEventListener('scroll',function(){var b=document.getElementById('scrollTop');if(window.scrollY>500)b.classList.add('show');else b.classList.remove('show')},{passive:true});

/* ═══ Gallery ═══ */
function swapImg(thumb,src){
  document.getElementById('mainImg').src=src;
  document.querySelectorAll('.thumb').forEach(function(t){t.classList.remove('active')});
  thumb.classList.add('active');
}

/* ═══ Purchase Toggle ═══ */
var purchaseType='sub';
function setPurchaseType(type){
  purchaseType=type;
  document.querySelectorAll('.pt-option').forEach(function(o){o.classList.remove('active')});
  if(type==='sub')document.querySelector('.pt-option.sub').classList.add('active');
  else document.querySelector('.pt-option.one').classList.add('active');
  updatePrices();
}
function setQty(card){
  document.querySelectorAll('.qty-card').forEach(function(c){c.classList.remove('active')});
  card.classList.add('active');
  updatePrices();
}

/* ═══ HOW TO CHANGE — Carousel ═══ */
var htcStep=0,htcTotal=5,htcPlaying=true,htcTimer=null,htcDur=4000,htcStart=null,htcRAF=null;

function goToStep(n){
  htcStep=n;
  document.querySelectorAll('.htc-img-wrap').forEach(function(w){w.classList.remove('active')});
  var iw=document.querySelector('.htc-img-wrap[data-step="'+n+'"]');if(iw)iw.classList.add('active');
  document.querySelectorAll('.htc-step-content').forEach(function(c){c.classList.remove('active')});
  var sc=document.querySelector('.htc-step-content[data-step="'+n+'"]');if(sc)sc.classList.add('active');
  document.querySelectorAll('.htc-tl-step').forEach(function(s,i){
    s.classList.remove('active','done');if(i<n)s.classList.add('done');if(i===n)s.classList.add('active');
    var pg=s.querySelector('.htc-tl-progress');if(pg)pg.style.strokeDashoffset='113';
  });
  var fill=document.getElementById('htcFill');if(fill)fill.style.width=(htcTotal>1?(n/(htcTotal-1))*100:0)+'%';
  startRing();if(htcPlaying)startAuto();
}
function startRing(){
  if(htcRAF)cancelAnimationFrame(htcRAF);htcStart=performance.now();
  var ad=document.querySelector('.htc-tl-step.active .htc-tl-progress');if(!ad)return;ad.style.strokeDashoffset='113';
  function tick(now){if(!htcPlaying){htcRAF=requestAnimationFrame(tick);return}var p=Math.min((now-htcStart)/htcDur,1);ad.style.strokeDashoffset=(113*(1-p)).toString();if(p<1)htcRAF=requestAnimationFrame(tick)}
  htcRAF=requestAnimationFrame(tick);
}
function startAuto(){clearTimeout(htcTimer);htcTimer=setTimeout(function(){if(htcPlaying)nextStep()},htcDur)}
function nextStep(){goToStep((htcStep+1)%htcTotal)}
function prevStep(){goToStep((htcStep-1+htcTotal)%htcTotal)}
function togglePlay(){
  htcPlaying=!htcPlaying;var btn=document.getElementById('htcPlay');
  if(htcPlaying){btn.textContent='❚❚';btn.classList.add('playing');htcStart=performance.now();startRing();startAuto()}
  else{btn.textContent='▶';btn.classList.remove('playing');clearTimeout(htcTimer)}
}
goToStep(0);

/* ═══ FAQ ═══ */
function toggleFaq(q){
  var item=q.parentElement,wasOpen=item.classList.contains('open');
  document.querySelectorAll('.faq-item').forEach(function(i){i.classList.remove('open')});
  if(!wasOpen)item.classList.add('open');
}

/* ═══ Decline Bars Animation ═══ */
(function(){
  var targets=[{id:'d1',w:98},{id:'d2',w:85},{id:'d3',w:60},{id:'d4',w:30}];
  var el=document.getElementById('declineVis');if(!el)return;
  var ob=new IntersectionObserver(function(es){if(es[0].isIntersecting){
    targets.forEach(function(t,i){setTimeout(function(){var bar=document.getElementById(t.id);if(bar)bar.style.width=t.w+'%'},i*300)});
    ob.unobserve(el);
  }},{threshold:.2});ob.observe(el);
})();

/* ═══ Inside Cards Animation ═══ */
(function(){
  ['ic1','ic2','ic3'].forEach(function(id,i){
    var el=document.getElementById(id);if(!el)return;
    var ob=new IntersectionObserver(function(es){if(es[0].isIntersecting){
      setTimeout(function(){
        el.classList.add('on');
        var fill=el.querySelector('.inside-eff-fill');
        if(fill)setTimeout(function(){fill.style.width=fill.dataset.w+'%'},150);
      },i*200);
      ob.unobserve(el);
    }},{threshold:.15});ob.observe(el);
  });
})();